<div class="context-menu" [ngStyle]="{ top: position.y + 'px', left: position.x + 'px' }" *ngIf="visible">
  <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" rel="stylesheet">

  <ul>
    <li (click)="ReplyText()">
      <ion-icon name="arrow-undo-outline"></ion-icon> Reply
    </li>
    <li *ngIf="ToggleRightClick==false" (click)="onSelect()">
      <ion-icon name="checkmark-circle-outline"></ion-icon> Select
    </li>
    <li *ngIf="ToggleRightClick==true" (click)="onSelect()">
      <ion-icon name="checkmark-circle-outline"></ion-icon> Unselect
    </li>
    <li (click)="CopyText()">
      <ion-icon name="copy-outline"></ion-icon> Copy Text
    </li>
    <li (click)="markasread()">
      <ion-icon name="eye-outline"></ion-icon> Mark as read
    </li>
    <li (click)="markasunread()">
      <ion-icon name="eye-off-outline"></ion-icon> Mark as unread
    </li>

  </ul>
</div>